import './styles/ImplementationPageBase.scss';

import { MainLayout } from '@whistler-ui/k2/components/MainLayout';
import { getUserFacingErrorMessage } from '@whistler-ui/k2/helpers/userFacingError';
import { useAppMessages, useClassHelper } from '@whistler-ui/k2/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetWebsheetBrands } from '../../hooks';
import { useEntitlementsStore } from '../../store/entitlements';
import { BasePages } from './components/BasePages';
import { ImplementationPagePropsType } from './types';

const componentName = 'c-ImplementationPageBase';

export const ImplementationPageBase = ({
  callbacks,
  pages,
  template,
  tag,
  templateType,
}: Omit<ImplementationPagePropsType, 'brand'>) => {
  const [setMessages] = useAppMessages();
  const c = useClassHelper(componentName);
  const { t } = useTranslation(['pages', 'common']);

  const { current: env } = useEntitlementsStore();

  const brandData = useGetWebsheetBrands(env?.id);

  useEffect(() => {
    if (brandData?.error) {
      setMessages({
        type: useAppMessages.type.ERROR,
        msg: getUserFacingErrorMessage(
          brandData?.error,
          'common:errors.default',
        ),
      });
    }
  }, [brandData?.error]);

  return (
    <MainLayout title={t('implementation_page_base.title', { context: tag })}>
      <section className={c('base')}>
        <BasePages
          callbacks={callbacks}
          pages={pages}
          template={template}
          tag={tag}
          templateType={templateType}
          brandData={brandData}
          brands={brandData.data}
        />
      </section>
    </MainLayout>
  );
};
